import { render, staticRenderFns } from "./MultiColumnsBlock.vue?vue&type=template&id=5bf6be20"
import script from "./MultiColumnsBlock.vue?vue&type=script&lang=ts"
export * from "./MultiColumnsBlock.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports